import { OfferCardFare } from "./offer-card-fare";
import { OfferT } from "../../../domain";
import React from "react";

type OfferCardTabletDetailsProps = {
  offer: OfferT;
  isDedicated?: boolean;
  children?: React.ReactNode;
};

export const OfferCardTabletDetails = ({
  offer,
  children,
}: OfferCardTabletDetailsProps): React.ReactElement => {
  return (
    <div className="hidden divide-x divide-dashed divide-[#9E9E9E] md:flex lg:hidden 2xl:flex">
      <div
        aria-label="Container with fare details content"
        className="mr-1 w-[247px] px-1"
      >
        <div className="flex h-full flex-col">
          <OfferCardFare offer={offer} />
          <div className="hidden self-end 2xl:flex">{children}</div>
        </div>
      </div>
    </div>
  );
};
